import React, { Component, PropTypes} from 'react'
import CSSModules from 'react-css-modules'
import Styles from './MorningstarLink.css'
import { Link, LinkIcon } from '../'
import config from '../../config'

@CSSModules(Styles,{allowMultiple:true})
export default class MorningstarLink extends Component {
  static propTypes = {
    url: PropTypes.string,
    ticker: PropTypes.string
  }
  constructor(props){
    super(props);
  }

  render() {
    const url = this.props.url || config.links.morningstar
    const morningstarLogo = require( '../../../static/images/img-morningstar.png' )
    return (
      <Link to={url}>
        <div styleName='morningstar-link-wrap'>
          <div styleName='morningstar-link-info'>
            Find fund performance
            <br/>
            and other financial metrics
            <br/>
            {this.props.ticker?'for '+this.props.ticker:null} on <span style={{whiteSpace:'nowrap'}}>Morningstar.com<LinkIcon /></span></div>
          <img styleName='morningstar-link-img' src={morningstarLogo} alt='Morningstar'/>
        </div>
      </Link>
    )
  }
}

